import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

const testimonials = [
  {
    heading: "Super fast withdrawals",
    desc: "Heng Ong Bet withdrawals is super fast. I was able to withdraw my winnings within 15 minutes. Thanks to the winnings from Heng Ong Bet, I managed to settle my outstanding housing loan.",
    by: "Faizal R., Kota Kinabalu",
  },
  {
    heading: "Unbeatable Payouts!",
    desc: "Heng Ong Bet is by far the best platform I’ve ever used! It offers the highest payout rates and the most rewarding promotions—truly a game-changer for online betting.",
    by: "Siti N., Kuala Lumpur",
  },
  {
    heading: "The Crypto Casino of My Choice",
    desc: "Depositing and withdrawing crypto with Heng Ong Bet is smooth and hassle-free—unlike many other platforms that don’t even support it.",
    by: "Kelvin L., Petaling Jaya",
  },
];

const Testimonial = () => {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={10}
      slidesPerView={1}
      loop={true}
      autoplay={{ delay: 3500, disableOnInteraction: false }}
      /*  style={{ width: "100%", height: "auto" }} */
    >
      {testimonials.map((testimonial, i) => {
        return (
          <>
            <SwiperSlide key={i}>
              <div key={i} className="testimonial-item">
                <p className="testimonial-head">{testimonial.heading}</p>
                <p className="testimonial-desc">{testimonial.desc}</p>
                <p className="testimonial-by">{testimonial.by}</p>
              </div>
            </SwiperSlide>
          </>
        );
      })}
    </Swiper>
  );
};

export default Testimonial;
